interface AnnualPlanData {
  id?: number;
  title?: string;
  isActive?: boolean;
  weeksLength?: number;
  startedAt?: string;
  endedAt?: string;
  weeklyWorkingTime?: number;
  comment?: string;
  athleteId?: number;
  libraryId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;

  firstName?: string;
  lastName?: string;

  rights?: string[];
  availableLangIds?: number[];
}

export class AnnualPlan {
  public static getNonTranslatableFields(): string[] { return ['id', 'title', 'isActive', 'weeksLength', 'startedAt', 'endedAt', 'weeklyWorkingTime', 'comment', 'athleteId', 'libraryId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'firstName', 'lastName']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'title', 'isActive', 'weeksLength', 'startedAt', 'endedAt', 'weeklyWorkingTime', 'comment', 'athleteId', 'libraryId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'firstName', 'lastName']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  title?: string;
  isActive?: boolean;
  weeksLength?: number;
  startedAt?: string;
  endedAt?: string;
  weeklyWorkingTime?: number;
  comment?: string;
  athleteId?: number;
  libraryId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;

  firstName?: string;
  lastName?: string;

  rights?: string[];
  availableLangIds?: number[];


  public static fromAPI(data: AnnualPlanData): AnnualPlan {
    return new AnnualPlan(data);
  }

  public static fromAPIList(data: AnnualPlanData[]): AnnualPlan[] {
    return data.map((item: AnnualPlanData) => AnnualPlan.fromAPI(item));
  }

  constructor({id, title, isActive, weeksLength, startedAt, endedAt, weeklyWorkingTime, comment, athleteId, libraryId,
                createDate, createrId, updateDate, updaterId, firstName, lastName, rights, availableLangIds} : AnnualPlanData) {
    this.id = id;
    this.title = title;
    this.isActive = isActive;
    this.weeksLength = weeksLength;
    this.startedAt = startedAt;
    this.endedAt = endedAt;
    this.weeklyWorkingTime = weeklyWorkingTime;
    this.comment = comment;
    this.athleteId = athleteId;
    this.libraryId = libraryId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.rights = rights;
    this.availableLangIds = availableLangIds;
  }

  public toJson(): AnnualPlanData {
    return {
      id: this.id,
      title: this.title,
      isActive: this.isActive,
      weeksLength: this.weeksLength,
      startedAt: this.startedAt,
      endedAt: this.endedAt,
      weeklyWorkingTime: this.weeklyWorkingTime,
      comment: this.comment,
      athleteId: this.athleteId,
      libraryId: this.libraryId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      firstName: this.firstName,
      lastName: this.lastName,
      availableLangIds: this.availableLangIds
    };
  }

  // check if the user has a specific right
  public hasRight(right: string): boolean {
    return this.rights?.includes(right) ?? false;
  }
}
